import { Injectable } from '@angular/core';
import * as color from '../../config/colors';
import * as backgroundColor from "../../config/backgroundColor";
import * as toolbox from "../../config/toolbox";
import * as tooltip from "../../config/tootip";
import * as timeline from "../../config/timeline";
import * as geo from "../../config/geo";
import * as visualMap from '../../config/visualMap';
import { CommonService } from '../../service/common.service';
import { displayType } from './timeline-map-interface';
import * as _ from 'lodash'

@Injectable({
  providedIn: 'root'
})
export class TimelineMapService {

  constructor(
    private commonService: CommonService,
  ) { }

  getTimelineMapDefaultOption(mapName: string = "beijing", displayType: displayType = "area") {
    let style = this.commonService.changeFontSize();

    let dimension = 0;
    if (displayType == 'area') {
      dimension = 0
    } else {
      dimension = 2
    }

    let defaultOption = {
      baseOption: {
        timeline: timeline.getCommonTimeline(style, []),
        backgroundColor: backgroundColor.backgroundColor,
        color: color.defaultColors,
        toolbox: toolbox.getToolboxIncludeRestore(style),
        geo: geo.getCommonGeo(style, mapName),
        visualMap: visualMap.getVisualMapOfPiecewise(style, dimension),
        tooltip: tooltip.getTooltipOfAreaMap(),
        series: [this.getSeriesByDisplayType(displayType)]
      },
      options: []
    }
    return defaultOption;
  }
  // 通过显示类型获取series
  getSeriesByDisplayType(displayType: displayType) {
    let style = this.commonService.changeFontSize();
    switch (displayType) {
      case 'area':
        return {
          type: 'map',
          roam: true,
          geoIndex: 0,
        }
      case 'point':
        return {
          type: 'scatter',
          coordinateSystem: "geo",
          label: {
            show: true,
            fontSize: style.fontSize - 2,
            color: '#000',
            position: 'top',
            formatter: '{b}'
          }
        }
      default:
        break;
    }
  }
  // 更改timeline数据
  changeTimelineData(chartOption, timelineData: string[]) {
    if (Array.isArray(timelineData) && timelineData.length > 0) {
      chartOption.baseOption.timeline.show = true;
      chartOption.baseOption.timeline.data = timelineData;
    } else {
      chartOption.baseOption.timeline.show = false;
    }
  }
  // 更改图数据
  changeChartData(chartOption, displayType: displayType, chartData: object[][] | { [key: string]: any[] }, geoCoordMap: any) {

    if (Array.isArray(chartData) && chartData.every(item => Array.isArray(item))) {
      if (displayType === 'area') {
        let options = [];
        chartData.forEach(element => {
          options.push({
            series: {
              data: element
            }
          })
        });
        chartOption.options = options
      } else if (displayType === 'point') {
        let options = [];
        chartData.forEach(element => {
          options.push({
            series: {
              data: this.convertData(element, geoCoordMap)
            }
          })
        })
        chartOption.options = options
      }
    } else {
      if (displayType === 'area') {
        let options = []
        options.push({
          series: {
            data: chartData
          }
        })
        chartOption.options = options
      } else if (displayType === 'point') {
        let options = [];
        options.push({
          series: {
            data: this.convertData(chartData, geoCoordMap)
          }
        })
        chartOption.options = options
      }
    }
  }
  // 更改映射维度
  changeVisualmapDimension(chartOption, bcacDisplayType, dimension = 0) {
    if (bcacDisplayType === 'point') {
      chartOption.baseOption.visualMap.dimension = dimension + 2;
      // chartOption.baseOption.series[0].label.formatter = `{b}`
    } else if (bcacDisplayType === 'area') {
      chartOption.baseOption.visualMap.dimension = dimension;
    }
  }

  // 更改显示类型
  changeDisplayType(chartOption, displayType: displayType) {

    chartOption.baseOption.series = [this.getSeriesByDisplayType(displayType)];
    if (displayType === 'point') {
      chartOption.baseOption.visualMap.dimension = 2;
      // chartOption.baseOption.series[0].label.formatter = `{b}`
    } else if (displayType === 'area') {
      chartOption.baseOption.visualMap.dimension = 0;
    }
  }
  // 修改维度名称 
  changeDimensionNames(chartOption, displayType: displayType, dimensionNames: { [key: string]: string }[]) {
    // chartOption.baseOption.series
    let names = [], units = [];
    for (const iterator of dimensionNames) {
      names.push(iterator.dimensionName)
      units.push(iterator.unit)
    }
    if (displayType == 'area') {

      for (let i = 0, length = chartOption.options.length; i < length; i++) {
        chartOption.options[i].series.dimensions = names;
      }
      chartOption.baseOption.tooltip = tooltip.getTooltipOfAreaMap(units);
    } else if (displayType == "point") {
      let pointName = ['lng', 'lat'];
      pointName = pointName.concat(names);

      for (let i = 0, length = chartOption.options.length; i < length; i++) {
        chartOption.options[i].series.dimensions = pointName;
      }
      chartOption.baseOption.tooltip = tooltip.getTooltipOfPointMap(units);
    }
  }

  // 修改分段
  changePieces(chartOption, pieces) {
    chartOption.baseOption.visualMap.pieces = pieces;
  }

  // 修改visualMap
  changeVisualMap(chartOption, displayType: "area" | "point", visualMaps: { type: 'continuous', data: { min: number, max: number, color?: string[] } } | { type: 'piecewise', data: { [key: string]: any }[] }) {
    let style = this.commonService.changeFontSize();
    let dimension = 0;
    if (displayType === "point") {
      dimension = 2;
    }
    if (!_.isEmpty(visualMaps)) {
      if (visualMaps.type === 'continuous') {
        chartOption.baseOption.visualMap = visualMap.getVisualMapOfContinuous(style, dimension, visualMaps.data.min, visualMaps.data.max);
        if (visualMaps.data.hasOwnProperty('color') && visualMaps.data.color.length > 0) {
          chartOption.baseOption.visualMap.inRange.color = visualMaps.data.color;
        }
      } else if (visualMaps.type === 'piecewise') {
        if (visualMaps.hasOwnProperty('data') && Array.isArray(visualMaps.data)) {

          chartOption.baseOption.visualMap = visualMap.getVisualMapOfPiecewise(style, dimension, visualMaps.data)
        } else {
          chartOption.baseOption.visualMap = visualMap.getVisualMapOfPiecewise(style, dimension)
        }
      }
    }
  }

  changeVisualMapPosition(chartOption, position: 'left' | 'right') {
    switch (position) {
      case 'left':
        chartOption.baseOption.visualMap.left = 0;
        delete chartOption.baseOption.visualMap.right;
        break;
      case 'right':
        chartOption.baseOption.visualMap.right = 0;
        delete chartOption.baseOption.visualMap.left;
        break;
      default:
        chartOption.baseOption.visualMap.left = 0;
        delete chartOption.baseOption.visualMap.right;
        break;
    }
  }

  // 转换数据
  convertData = (data, geoCoordMap) => {
    var res = [];
    for (var i = 0; i < data.length; i++) {
      var geoCoord = geoCoordMap[data[i].name];
      if (geoCoord) {
        res.push({
          name: data[i].name,
          value: geoCoord.concat(data[i].value)
        });
      }
    }
    return res;
  }
}
